import React from "react";
import { connect } from "react-redux";
import {
  guardarAplicacionExterna,
  editarAplicacionExterna,
} from "../../components/aplicacionExterna/AplicacionExternaService";
import { idEmpresa, admin } from "../../constans/constants";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { validateForm } from "../../constans/validationUtils";
import BreadCrumComponent from '../../components/componentes/BreadCrumComponent';
import { showhidePassword } from '../../assets/js/scripts/showhidepassword';
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica, integrarConChkClick,
  integrarConHandleInput
} from '../../constans/form-error-utils';

class AplicacionExterna extends React.Component {
  constructor(props) {
    super(props);

    const { tipoAccion } = props.match.params;
    const originalHandleInput = this.handleInput;
    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      aplicacion: "",
      descripcion: "",
      url: "",
      usuario: "",
      pwd: "",
      errors: {
        aplicacion: null,
        descripcion: null,
        url: null,
        usuario: null,
        pwd: null,
        empresa: null,
        listaEmpresaSelected: null
      },
      id: "",
      mensaje: "",
      severity: "",
      openPantallaCarga: false,
      validated: false,
      listaEmpresas: props.listaEmpresa,
      listaEmpresaSelected: "",
      tipoAccion,
      titulo: null
    };
  }

  reglasValidacionCampos = {
    aplicacion: [
      { required: true, message: 'Ingrese el nombre de la aplicacion externa' },
    ],
    descripcion: [
      { required: true, message: 'Ingrese una descripcion corta' },
    ],
    url: [
      { required: true, isURL: true, message: 'Campo obligatorio' },
    ],
    usuario: [
      { required: true, message: 'Ingrese el nombre de usuario para la aplicacion externa' },

    ],
    pwd: [
      { required: true, message: 'Ingrese una contraseña para la aplicacion externa' },

    ],
    listaEmpresaSelected: [
      {
        customValidator: (value, formData) => {
          if (!admin())
            return true
          else
            return value > 0
        }, message: 'Debe seleccionar una empresa'
      },
    ]
  }

  handleClose = () => {
    this.props.handleClose(false, this.state.mensaje, this.state.severity);
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleAplicacionExternaSubmit = event => {
    event.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({});
      this.setState({ openPantallaCarga: true });
      if (this.state.tipoAccion === "edit") {
        const json = {
          aplicacion: this.state.aplicacion,
          descripcion: this.state.descripcion,
          url: this.state.url,
          usuario: this.state.usuario,
          password: this.state.pwd,
          id: this.state.id,
          idEmpresa: this.props.isAdmin ? this.state.listaEmpresaSelected : idEmpresa()
        };
        this.props.editarAplicacionExterna(json).then((response) => {
          this.props.history.push({
            pathname: `/configuracion/aplicaciones-externas`,
            state: {
              mensajeFlash: response.mensaje,
              mostrarMensajeFlash: true,
              mensajeFlashSeverity: response.error ? "error" : "exito",
            }
          });
        });
      }
      const json = {
        aplicacion: this.state.aplicacion,
        descripcion: this.state.descripcion,
        url: this.state.url,
        usuario: this.state.usuario,
        password: this.state.pwd,
        idEmpresa: this.props.isAdmin ? this.state.listaEmpresaSelected : idEmpresa()
      };
      this.props.guardarAplicacionExterna(json).then((response) => {
        this.props.history.push({
          pathname: `/configuracion/aplicaciones-externas`,
          state: {
            mensajeFlash: response.mensaje,
            mostrarMensajeFlash: true,
            mensajeFlashSeverity: response.error ? "error" : "exito",
          }
        });
      });

    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };

  componentDidMount() {

    showhidePassword()
    configurarLimpiezaAutomatica()

    if (this.state.tipoAccion === "edit") {
      const { aplicacionExterna } = this.props.location.state;
      this.setState({
        aplicacion: aplicacionExterna.aplicacion,
        descripcion: aplicacionExterna.descripcion,
        url: aplicacionExterna.url,
        usuario: aplicacionExterna.usuario,
        pwd: aplicacionExterna.password,
        id: aplicacionExterna.id,
        listaEmpresaSelected: aplicacionExterna.empresa.id,
        titulo: "Datos de la aplicacion: " + aplicacionExterna.aplicacion
      });
    }
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  handleChangeSelect = (e) => {
    let val = e.target.value
    let name = e.target.name
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))

  }

  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={'/configuracion/aplicaciones-externas'}
                breadcrumbs={
                  [
                    { label: 'Configuraciones', path: '/configuracion/tipo-documento' },
                    { label: 'Aplicaciones externas', path: '/configuracion/aplicaciones-externas' },
                    { label: this.props.match.params.tipoAccion !== 'edit' ? 'Registrar aplicacion externa' : 'Editar aplicacion externa', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> {this.state.titulo ?? "Registrar nueva aplicacion externa"}  </h1>
                  <p className="page-description"> Complete el siguiente formulario con los datos solicitados </p>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">

              <div className="component-content card">
                <form onSubmit={this.handleAplicacionExternaSubmit} className="form container-sm">

                  <div className="form-group__inline">
                    <div className="form-group">
                      <input type="text" name="aplicacion" id="aplicacion" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.aplicacion} />
                      <label htmlFor="aplicacion" className="form-label"> Nombre de la aplicacion </label>
                    </div>

                    <div className="form-group">
                      <input type="text" name="descripcion" id="descripcion" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.descripcion} />
                      <label htmlFor="descripcion" className="form-label"> Descripción </label>
                    </div>
                  </div>

                  <div className="form-group">
                    <input type="url" name="url" id="url" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.url} />
                    <label htmlFor="url" className="form-label"> URL </label>
                  </div>

                  <div className="form-group__inline">
                    <div className="form-group">
                      <input type="text" name="usuario" id="usuario" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.usuario} />
                      <label htmlFor="usuario" className="form-label"> Nombre de usuario </label>
                    </div>
                    <div className="form-group group-icon">
                      <input type="password" name="pwd" id="pwd" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.pwd} />
                      <label htmlFor="pwd" className="form-label"> Password </label>
                      <button className="input-icon toggle-password" type="button"> <span className="material-symbols-outlined"> visibility </span> </button>
                    </div>
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-medium btn-primary"> GUARDAR </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
          <PantallaCarga open={this.state.openPantallaCarga} />
        </div>
      </div>

    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  guardarAplicacionExterna: (value) =>
    dispatch(guardarAplicacionExterna(value)),
  editarAplicacionExterna: (value) => dispatch(editarAplicacionExterna(value)),
});

export default connect(null, mapDispatchToProps)(AplicacionExterna);
